import type {
  GetScheduleServices,
  ScheduleService,
  ScheduleServiceCosts,
} from '@entities/schedules/service/types.ts';
import { numberWithSeparator } from '@shared/helpers/index.ts';

export const getScheduleServiceCost = ({ min, max }: ScheduleServiceCosts) =>
  min === max
    ? String(numberWithSeparator(min))
    : `${numberWithSeparator(min)} - ${numberWithSeparator(max)}`;

export const getScheduleServiceDuration = (services: Partial<ScheduleService>[] | undefined) =>
  (services && services.length !== 0 && services[0].duration) || undefined;

export const getSelectedServices = ({
  data,
  selectedIds,
}: {
  data?: GetScheduleServices;
  selectedIds?: number[];
}): ScheduleService[] => {
  const output: ScheduleService[] = [];
  selectedIds &&
    data &&
    Object.keys(data).forEach((duration) =>
      data[duration].forEach((service) => selectedIds.includes(service.id) && output.push(service))
    );
  return output;
};

export const getMinCostFromScheduleServicesArray = (services?: ScheduleService[]) => {
  let minCost = Number.MIN_SAFE_INTEGER;
  services?.forEach((el) => el.costs.min > minCost && (minCost = el.costs.min));
  return minCost;
};
